import { adapi } from '~';
import _ from 'lodash';


const SET_CURRENT = 'SET_CURRENT';
const SET_LOADING = 'SET_LOADING';

const getters = {
  currentCampaign(state) {
    return state.current;
  },
  currentFacebookPage(state) {
    if (state.current) {
      return state.current.fbpage;
    }
    return null;
  },
  currentLandingPages(state) {
    if (state.landingpages) {
      return state.landingpages;
    }
    return [];
  },
  currentIteration(state) {
    if (state.current && state.current.iterations) {
      return _.find(state.current.iterations, iter => iter.finish_date === '0000-00-00 00:00:00' || iter.finish_date === null);
    }
    return null;
  },
};

const actions = {
  getCampaign({ commit }, code) {
    commit(SET_LOADING, true);
    return adapi.get(`campaigns/${code}`)
      .then(result => {
        commit(SET_CURRENT, { current: result, error: null });
        commit(SET_LOADING, false);
      })
      .catch(error => {
        commit(SET_CURRENT, { current: null, error });
        commit(SET_LOADING, false);
      });
  },
  setLandingPage({ state, commit }, landingpage) {
    return adapi.post(`campaigns/${state.current.code}/landingpages`, null, { landingpage })
      .then(current => commit(SET_CURRENT, { current }));
  },
  setFacebookPage({ state, commit }, pageUrl) {
    return adapi.post(`campaigns/${state.current.code}/claim-facebook-page`, null, { pageUrl })
      .then(current => commit(SET_CURRENT, { current }));
  },
  getLeadsReport({ state }) {
    return adapi.post(`campaigns/${state.current.code}/getLeadsReport`, null, {});
  },
  acceptPost({ state, dispatch }, postId) {
    return adapi.get(`post/${postId}/approve`)
      .then(() => {
        dispatch('getCampaign', state.current.code);
      });
  },
  setStartDate({ state, commit }, startDate) {
    return adapi.post(`campaigns/${state.current.code}/startdate`, null, { startDate })
      .then(current => commit(SET_CURRENT, { current }));
  },
  removeCurrentCampaign({ commit }) {
    commit(SET_CURRENT, { current: null, error: null });
    commit(SET_LOADING, false);
  },
  setCurrentCampaign({ commit }, campaign) {
    commit(SET_CURRENT, { current: campaign, error: null });
    commit(SET_LOADING, false);
  },
  reloadCampaign({ commit, state }, loading = false) {
    if (loading) commit(SET_LOADING, true);

    return adapi.get(`campaigns/${state.current.code}`)
      .then(result => {
        commit(SET_CURRENT, { current: result, error: null });
        if (loading) commit(SET_LOADING, false);
      })
      .catch(() => {
        if (loading) commit(SET_LOADING, false);
      });
  },
  setAutoPublish({ state, commit }, value) {
    return adapi.post(`campaigns/${state.current.code}/autopublish`, null, { value })
      .then(current => commit(SET_CURRENT, { current }));
  },
};

const mutations = {
  [SET_CURRENT](state, { current, error }) {
    state.current = current;
    state.error = error;
  },
  [SET_LOADING](state, loading) {
    state.loading = loading;
  },
};

export default {
  namespaced: true,
  state: {
    current: null,
    error: null,
    loading: false,
  },
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/campaign.js